import { ControllerPage } from '../_app/cuchillo/pages/ControllerPage';
import Preloader from '../layout/Preloader';
import Wrap from '../layout/Wrap';
import AudioController from '../layout/AudioController';
import Default from './Default';

// Pàgina especial 404: idèntica a Default però NO activa l'audio layer (l'amaga directament,
// com fa el mode debug). El link "Volver al inicio" del bloc not-found és data-internal →
// recàrrega completa a la home, on l'audio layer torna a aparèixer (show__effect amb isFirstTime).
export default class NotFound extends Default {
  show__effect(__call) {
    // if (this.isFirstTime) {
    Preloader.directHide(() => {
      AudioController.directHide();
      Wrap.show(() => { this.afterShow(); });
    });
    // } else {
    //   Wrap.show(() => { this.afterShow(); });
    // }
  }
}

ControllerPage._addPage('page-not-found', NotFound);
